/**
 * Created by Ning Jiang on 2021-05-03.
 */

import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {IFadeTrackConf, IPlayTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {gsap, TimelineLite} from "gsap";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {NolimitConfig} from "@nolimitcity/slot-launcher/bin/settings/NolimitConfig";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {SoundEffectGroup} from "./SoundEffectGroup";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";

export class DeadwoodRipSound {

    public static AS_WIN:string = "asWin";
    public static AS_WIN_BIG:string = "asWinBig";
    public static XBET:string[] = ["xBetOff", "xBet1", "xBet2"];

    public static MAIN_GAME_MUSIC:string = "main";
    public static FREE_SPIN_MUSIC:string = "fs";
    public static SUPER_FREE_SPIN_MUSIC:string = "sfs";

    public static FREE_SPIN_INTRO_START:string = "fsIntroStart";
    public static FREE_SPIN_INTRO:string = "fsIntroLoop";
    public static FREE_SPIN_START:string = "fsStart";

    public static FREE_SPIN_END:string = "fsEnd";
    public static FREE_SPIN_END_GOOD:string = "fsEndGood";
    public static FREE_SPIN_END_BAD:string = "fsEndBad";
    public static FREE_SPIN_OUTRO_END:string = "fsOutroEnd";

    public static CAP_WIN_COUNT_UP:string = "capWinCountup";
    public static CAP_WIN_LOOP:string = "capWinLoop";

    public static REELS_SPINNING:string = "reelsSpinning";

    public static SHOOT_EMPTY:string = "gunFireDry";

    public static COUNT_UP_COUNTER:string = "countupCounter";
    public static COUNT_UP_END_SMALL:string = "countupEndsSmall";
    public static COUNT_UP_END_MEDIUM:string = "countupEndsMedium";
    public static COUNT_UP_END_LARGE:string = "countupEndsLarge";
    public static COUNT_UP_MULTIPLIER:string = "countupMultiplier";

    public static BIG_WIN_INTRO:string = "bigwinIntro";
    public static BIG_WIN:string[] = ["bigwin1", "bigwin2", "bigwin3", "bigwin4", "bigwin5", "bigwin6"];
    public static BIG_WIN_END:string = "bigwinEnd";
    public static BIG_WIN_COUNT_UP:string = "bigwinCountup";
    public static BIG_WIN_COUNT_UP_ENDS:string = "bigwinCountupEnds";

    public static NUDGE_LAND:string[] = ["nudge1Land", "nudge2Land", "nudge3Land"];
    public static NUDGE_STEP:string[] = ["nudgeNudge1", "nudgeNudge2"];
    public static NUDGE_STEP_FINAL:string[] = ["nudge1NudgeFinal", "nudge2NudgeFinal", "nudge3NudgeFinal"];
    public static NUDGE_TO_MULTI:string[] = ["nudge1ToMult", "nudge2ToMult", "nudge3ToMult"];

    public static BADGE1_LAND:string = "badge1Land";
    public static BADGE2_LAND:string = "badge2Land";
    public static BADGE_LOW_TO_WILD:string = "badgeLowsToWild";

    public static QUICK_DRAW_LAND:string = "quickdrawLand";
    public static QUICK_DRAW_ACTIVATE:string = "quickdrawActivate";
    public static QUICK_DRAW_FIRE:string = "quickdrawFire";
    public static QUICK_DRAW_NO_WIN:string = "quickdrawNowin";

    public static SCATTER_ANTICIPATION:string = "scatterAnticipation";
    public static SCATTER_ANTICIPATION_FAIL:string = "scatterAnticipationFail";
    public static SCATTER_ANTICIPATION_SUCCESS:string = "scatterAnticipationSuccess";
    public static SCATTER_FS_ANTICIPATION_FAIL:string = "scatterFsAnticipationFail";
    public static SCATTER_FS_ANTICIPATION_SUCCESS:string = "scatterFsAnticipationSuccess";
    public static SCATTER_ANTICIPATION_2:string = "scatterAnticipation2";
    public static SCATTER_ANTICIPATION_2_LAND:string = "scatterAnticipation2Land";

    public static S1_LAND:string[] = ["scatterLand1", "scatterLand2"];
    public static S1_WIN:string = "scatterFlash";
    public static SCATTER_TO_WILD:string = "scatterToWild";

    public static S1_FS_LAND:string[] = ["scatterFsLand1", "scatterFsLand2"];
    public static S1_FS_HIGHLIGHT:string = "scatterFsHighlight";

    public static S2_LAND:string = "scatter2Land";
    public static S2_SPLIT_PIG:string = "scatter2Split";
    public static S2_WIN:string = "scatter2Flash";

    public static AXE_APPEAR:string = "wildSplitAxe";
    public static AXE_HIT:string = "wildSplit";
    public static SYMBOL_SPLIT:string = "wildSplitSym";

    public static XRIP:string = "xrip";

    public static _davidPanningReelStop:number[] = [-0.14, -0.07, 0, 0.07, 0.14];
    private static _davidPanningShot:number[] = [-0.24, -0.14, -0.07, 0, 0.07, 0.14, 0.24];
    private static _davidPanningHit:number[] = [-0.3, -0.18, -0.09, 0, 0.09, 0.18, 0.3];

    public static get soundPlayer():NolimitAudioPlayer {
        return <NolimitAudioPlayer>SlotGame.sound;
    }

    constructor() {
        if(NolimitConfig.isDevMode) {
            DeadwoodRipSound.soundPlayer.showLogs(true);
        }
        NolimitSlotAudio.apiPlugIn.settings.on(APISetting.SFX, (value:any) => this.onSFX(value));
    }

    private static _currentMusic:string;

    public static switchMusic(conf:IPlayTrackConf, fadeInConf?:IFadeTrackConf, fadeOutConf?:IFadeTrackConf):void {
        if(fadeInConf && fadeInConf.name != conf.name) {
            debugger;
            Logger.logDev(`WARNING: switching music fade in conf name doesn't match the new music name!`);
        }

        if(conf.name === DeadwoodRipSound._currentMusic) {
            if(fadeInConf) {
                DeadwoodRipSound.soundPlayer.fadeTrack(fadeInConf);
            }
            return;
        }

        if(DeadwoodRipSound._currentMusic != null) {
            if(fadeOutConf) {
                fadeOutConf.name = this._currentMusic;
                const fade = DeadwoodRipSound.soundPlayer.fadeTrack(fadeOutConf);
                const fadeName = this._currentMusic;
                if(fade) {
                    gsap.to(this, {
                        duration : fadeOutConf.duration / 1000,
                        onComplete : () => {DeadwoodRipSound.soundPlayer.stopTrack(fadeName);}
                    });
                } else {
                    DeadwoodRipSound.soundPlayer.stopTrack(fadeName);
                }
            } else {
                DeadwoodRipSound.soundPlayer.stopTrack(DeadwoodRipSound._currentMusic);
            }
        }

        DeadwoodRipSound.soundPlayer.playTrack(conf);
        if(fadeInConf) {
            DeadwoodRipSound.soundPlayer.fadeTrack(fadeInConf);
        }
        DeadwoodRipSound._currentMusic = conf.name;
    }

    // Use this to handle the music, eg, fade out/in music in big win, and you don't need to care what music is playing
    public static fadeMusic(vol:number, duration:number):void {
        DeadwoodRipSound.soundPlayer.fadeTrack({
            name : DeadwoodRipSound._currentMusic,
            to : vol,
            duration : duration
        });
    }

    public static getMusicNameByMode(mode:GameMode | string):string {
        switch(mode) {
            case GameMode.FREESPIN_SUPER:
                return DeadwoodRipSound.SUPER_FREE_SPIN_MUSIC;
            case GameMode.FREESPIN:
                return DeadwoodRipSound.FREE_SPIN_MUSIC;
            default:
                return DeadwoodRipSound.MAIN_GAME_MUSIC;
        }
    }

    public static fadeAndStopSound(fadeOutConf:IFadeTrackConf):void {
        const fade = DeadwoodRipSound.soundPlayer.fadeTrack(fadeOutConf);
        if(fade) {
            gsap.to(this, {
                duration : fadeOutConf.duration / 1000,
                onComplete : () => {DeadwoodRipSound.soundPlayer.stopTrack(fadeOutConf.name);}
            });
        } else {
            DeadwoodRipSound.soundPlayer.stopTrack(fadeOutConf.name);
        }
    }

    public static PLAYING_LOOP_EFFECTS:string[] = [];

    private onSFX(value:any):void {
        if(!DeadwoodRipSound.soundPlayer.isLoaded) {
            return;
        }
        if(!NolimitSlotAudio.apiPlugIn.settings.get("mute")) {
            return;
        }
        if(!value) {
            return;
        }
        DeadwoodRipSound.PLAYING_LOOP_EFFECTS.forEach(name => {
            DeadwoodRipSound.playLoopEffect(name);
        });
    }

    // play loop effect even the trigger is when sound is off, it will play when sound is on.
    public static playLoopEffect(name:string):void {
        if(DeadwoodRipSound.PLAYING_LOOP_EFFECTS.indexOf(name) === -1) {
            DeadwoodRipSound.PLAYING_LOOP_EFFECTS.push(name);
        }
        const player = DeadwoodRipSound.soundPlayer.fetchSoundPlayer(name);
        if(player && !player.isPlaying) {
            DeadwoodRipSound.soundPlayer.playTrack({name : name, repeat : 10000});
        }
    }

    public static stopLoopEffect(name:string):void {
        ArrayHelper.removeFirstMatchElement(DeadwoodRipSound.PLAYING_LOOP_EFFECTS, name);
        DeadwoodRipSound.soundPlayer.stopTrack(name);
    }

    private static _reelLandingGroup:SoundEffectGroup;

    public static playRandomReelLandingSound():NolimitHowl | undefined {
        if(!DeadwoodRipSound._reelLandingGroup) {
            DeadwoodRipSound._reelLandingGroup = new SoundEffectGroup(["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"]);
        }

        return DeadwoodRipSound._reelLandingGroup.playRandom();
    }

    private static _reelWinHighlightGroup:SoundEffectGroup;

    public static playReelWinHighlightSound():NolimitHowl | undefined {
        if(!DeadwoodRipSound._reelWinHighlightGroup) {
            DeadwoodRipSound._reelWinHighlightGroup = new SoundEffectGroup(["winHighlight01", "winHighlight02", "winHighlight03", "winHighlight04"]);
        }

        return DeadwoodRipSound._reelWinHighlightGroup.playRandomNoOverlap();
    }

    private static _quickDrawHitGroup:SoundEffectGroup;

    public static playQuickDrawHitSound():NolimitHowl | undefined {
        if(!DeadwoodRipSound._quickDrawHitGroup) {
            DeadwoodRipSound._quickDrawHitGroup = new SoundEffectGroup(["quickdrawHit01", "quickdrawHit02", "quickdrawHit03"]);
        }

        return DeadwoodRipSound._quickDrawHitGroup.playRandom();
    }

    public static getDefaultGunShotEmptyTimeline(stereoIndex:number):TimelineLite {
        const tl = new TimelineLite();
        tl.add(() => {
            DeadwoodRipSound.playDefaultGunShot(stereoIndex);
        });
        tl.add(() => {
            // TODO: play what ever hit.
        }, 0.025);
        return tl;
    }

    public static getDefaultGunShotWoodTimeline(stereoIndex:number):TimelineLite {
        const tl = new TimelineLite();
        tl.add(() => {
            DeadwoodRipSound.playDefaultGunShot(stereoIndex);
        });
        tl.add(() => {
            DeadwoodRipSound.playHitWood(stereoIndex);
        }, 0.025);
        return tl;
    }

    public static getDefaultGunShotBodyTimeline(stereoIndex:number):TimelineLite {
        const tl = new TimelineLite();
        tl.add(() => {
            DeadwoodRipSound.playDefaultGunShot(stereoIndex);
        });
        tl.add(() => {
            DeadwoodRipSound.playHitBody(stereoIndex);
        }, 0.025);
        return tl;
    }

    public static playDefaultGunShot(stereoIndex:number):void {
        const shot = DeadwoodRipSound.playGunFire();
        if(shot) {
            shot.player.stereo(DeadwoodRipSound._davidPanningShot[stereoIndex]);
            if(Math.random() > 0.5) {
                const rico = DeadwoodRipSound.playGunRico();
                if(rico) {
                    rico.player.stereo(DeadwoodRipSound._davidPanningShot[stereoIndex]);
                }
            }
        }
    }

    private static _gunShootRicoGroup:SoundEffectGroup;

    public static playGunRico():NolimitHowl | undefined {
        if(!DeadwoodRipSound._gunShootRicoGroup) {
            DeadwoodRipSound._gunShootRicoGroup = new SoundEffectGroup(["gunRico01", "gunRico02", "gunRico03", "gunRico04"]);
        }
        return DeadwoodRipSound._gunShootRicoGroup.playRandomNoOverlap();
    }

    private static _gunFireGroup:SoundEffectGroup;

    public static playGunFire():NolimitHowl | undefined {
        if(!DeadwoodRipSound._gunFireGroup) {
            DeadwoodRipSound._gunFireGroup = new SoundEffectGroup(["gunFire01", "gunFire02", "gunFire03", "gunFire04"]);
        }
        return DeadwoodRipSound._gunFireGroup.playRandomNoOverlap();
    }

    private static _gunHitWoodGroup:SoundEffectGroup;

    public static playHitWood(stereoIndex:number):void {
        if(!DeadwoodRipSound._gunHitWoodGroup) {
            DeadwoodRipSound._gunHitWoodGroup = new SoundEffectGroup(["gunHitWood01", "gunHitWood02", "gunHitWood03", "gunHitWood04"]);
        }
        const hit = DeadwoodRipSound._gunHitWoodGroup.playRandomNoOverlap();
        if(hit) {
            hit.player.stereo(DeadwoodRipSound._davidPanningHit[stereoIndex]);
        }
    }

    private static _gunHitBodyGroup:SoundEffectGroup;

    public static playHitBody(stereoIndex:number):void {
        if(!DeadwoodRipSound._gunHitBodyGroup) {
            DeadwoodRipSound._gunHitBodyGroup = new SoundEffectGroup(["gunHitBody01", "gunHitBody02", "gunHitBody03", "gunHitBody04"]);
        }
        const hit = DeadwoodRipSound._gunHitBodyGroup.playRandomNoOverlap();
        if(hit) {
            hit.player.stereo(DeadwoodRipSound._davidPanningHit[stereoIndex]);
        }
    }

    private static _killM1Ground:SoundEffectGroup = new SoundEffectGroup(["gunHitM101", "gunHitM102", "gunHitM103"]);
    private static _killM2Ground:SoundEffectGroup = new SoundEffectGroup(["gunHitM201", "gunHitM202", "gunHitM203"]);
    private static _killM3Ground:SoundEffectGroup = new SoundEffectGroup(["gunHitM301", "gunHitM302", "gunHitM303"]);
    private static _killM4Ground:SoundEffectGroup = new SoundEffectGroup(["gunHitM401", "gunHitM402", "gunHitM403"]);
    private static _killM5Ground:SoundEffectGroup = new SoundEffectGroup(["gunHitM501", "gunHitM502", "gunHitM503"]);
    private static _killSGround:SoundEffectGroup = new SoundEffectGroup(["gunHitS"]);
    private static _killWXN1Ground:SoundEffectGroup = new SoundEffectGroup(["gunHitW1"]);
    private static _killWXN2Ground:SoundEffectGroup = new SoundEffectGroup(["gunHitW2"]);
    private static _killWXN3Ground:SoundEffectGroup = new SoundEffectGroup(["gunHitW3"]);
    private static _killWRSGround:SoundEffectGroup = new SoundEffectGroup(["gunHitWRS01", "gunHitWRS02", "gunHitWRS03"]);

    public static playSymbolKill(symName:string, stereoIndex:number):void {
        const kill = (<SoundEffectGroup>(<any>DeadwoodRipSound)[`_kill${symName}Ground`]).playRandomNoOverlap();
        if(kill) {
            kill.player.stereo(DeadwoodRipSound._davidPanningHit[stereoIndex]);
        }
    }

    public static playS1Land(amount:number, reelId:number):void {
        if(amount > 0) {
            const sound = DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.S1_LAND[amount - 1]});
            if(sound) {
                sound.player.stereo(DeadwoodRipSound._davidPanningReelStop[reelId]);
            }
        }
    }

    public static playS1FSLand(amount:number, reelId:number):void {
        if(amount > 0) {
            const sound = DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.S1_FS_LAND[amount - 1]});
            if(sound) {
                sound.player.stereo(DeadwoodRipSound._davidPanningReelStop[reelId]);
            }
        }
    }
}